import React from "react";
import PropTypes from "prop-types";
import Badge from "antd/es/badge";
import Card from "antd/es/card";
import Col from "antd/es/col";
import Row from "antd/es/row";

const KeyDetails = ({ transactionRecord }) => (
  <Card style={{ marginTop: "20px", borderColor: "#ffb551" }}>
    <Row type="flex" justify="space-between">
      <Col style={{ paddingTop: "5px" }}>
        <Badge count={"Key Details"} className="details-badge" />
      </Col>
    </Row>

    <div className="left-margin">
      <Row>
        <Col span={8}><span className="details-label">{"Rooms"}</span></Col>
        <Col span={8}><span className="details-label">{"No. of Keys"}</span></Col>
      </Row>
      {transactionRecord.roomKeysData.map((roomItem, index) => {
        return (
          <Row key={index}>
            <Col span={8}><span className="details-value">{roomItem.room || "-"}</span></Col>
            <Col span={8}><span className="details-value">{roomItem.no_of_keys || "-"}</span></Col>
          </Row>
        );
      })}
    </div>
  </Card>
);

KeyDetails.propTypes = {
  transactionRecord: PropTypes.object.isRequired,
};

export default KeyDetails;
